<template>
  <v-app id="body">
    <div v-if="!this.$route.path.match(/home/)">
      <navigation-drawer :nav_list="nav_list"></navigation-drawer>
    </div>
    <v-main>
      <div class="">
        <router-view :nav_list="nav_list"></router-view>
      </div>
    </v-main>

    <!-- <v-footer app dark> Footer </v-footer> -->
  </v-app>
</template>

<script>
import NavigationDrawer from "./components/layouts/Navigation-Drawer.vue";

export default {
  components: {
    NavigationDrawer,
  },
  data() {
    return {
      nav_list: [
        {
          name: "Home",
          icon: "mdi-home",
          link: "/home/",
        },
        {
          name: "About",
          icon: "mdi-account-circle",
          link: "/profile/",
        },
        {
          name: "Skill",
          icon: "mdi-toolbox",
          active: false,
          link: "/skill/programming/",
          lists: [
            { name: "Programming", link: "/skill/programming/" },
            { name: "Others", link: "/skill/others/" },
          ],
        },
        { name: "Product", icon: "mdi-tools", link: "/productions/" },
      ],
    };
  },
  methods: {
    createTitleDesc: function (routeInstance) {
      //titleを設定する処理
      if (routeInstance.meta.title) {
        var setTitle = routeInstance.meta.title + " | IU-Portfolio";
        document.title = setTitle;
      } else {
        document.title = "タイトル未設定";
      }

      // メタタグのdescription設定処理
      if (routeInstance.meta.desc) {
        var setDesc = routeInstance.meta.desc + " | IU-Portfolio";
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", setDesc);
      } else {
        document
          .querySelector("meta[name='description']")
          .setAttribute("content", "ディスクリプションはありません");
      }
    },
  },
  mounted() {
    sessionStorage.setItem("access", true);
    var routeInstance = this.$route;
    this.createTitleDesc(routeInstance);
  },
  watch: {
    $route(routeInstance) {
      this.createTitleDesc(routeInstance);
    },
  },
};
</script>

<style>
#body {
  /* background:rgba(186,211,255,0.25); */
  background-color: #111;
  background-image: radial-gradient(#333, #111);
  color: #fff;
  font-family: "Montserrat", sans-serif;
}

h1 {
  padding: 20px;
  text-align: center;
}

.skew {
  animation: skew 10s infinite;
}

@keyframes skew {
  0% {
    transform: none;
  }
  33% {
    transform: none;
  }
  33.3% {
    transform: skewX(5deg);
  }
  33.6% {
    transform: skewX(-5deg);
  }
  33.9% {
    transform: none;
  }
  66% {
    transform: none;
  }
  /* 66.3% {
    transform: skewX(5deg);
  }
  66.6% {
    transform: skewX(-5deg);
  } */
  66.9% {
    transform: none;
  }
  77% {
    transform: none;
  }
  77.3% {
    transform: skewX(15deg);
  }
  77.6% {
    transform: skewX(-15deg);
  }
  77.9% {
    transform: none;
  }
}
</style>